import service, {clickEventId} from "@irati-tracking/tracker"

const CULTURE_HUB_TRACKING_ROOT = "culture_hub"

const tracking = {
  cultureHubHasTiles: () => service.trackEvent(`${CULTURE_HUB_TRACKING_ROOT}_has_tiles`, {}),
  cultureHubTileClick: (tileUrl: string, culture_hub_count: number, source = "organic") => {
    const data = {
      tileUrl,
      culture_hub_count,
      source
    }
    service.trackEvent(`${CULTURE_HUB_TRACKING_ROOT}_tile_click`, data)
  },
  cultureHubClick: (culture_hub_count: number) => {
    service.trackEvent("culture_hub_view", {culture_hub_count})
  },
  clickCultureHubCta: (source: string, type: string) => {
    service.trackEvent(clickEventId, {source, type})
  }
}

export default tracking
